const icon = {
    lineHeight: { value: 1 },
    height: { value: '1em' }, // Should match height of parent container font-size
};

export { icon };
